import { FlatButton } from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import { statisticsByAgreedVolumeTableConfig } from "../config/StatisticsByAgreedVolumeTableConfig";
import { useFilterWorkspace } from "@/features/search-filter/hooks/UseFilterWorkspace";
import { StatisticsByAgreedVolumeListItem } from "@/gql/graphql";
import { ApolloError } from "@apollo/client";

const config = statisticsByAgreedVolumeTableConfig();

interface Props {
  loading: boolean;
  noFiltersSelected: boolean;
  agreedVolumeItems?: StatisticsByAgreedVolumeListItem[];
  error?: ApolloError;
}

export const StatisticsByAgreedVolumeTable = ({
  loading,
  agreedVolumeItems,
  error,
  noFiltersSelected,
}: Props) => {
  const { openFilter } = useFilterWorkspace();

  return (
    <StandardTable
      loading={loading}
      items={agreedVolumeItems}
      error={error}
      config={config}
      noItemsHeader={
        noFiltersSelected
          ? "Search for Agreed Volume"
          : "Your search did not return any results"
      }
      noItemsLabel={
        noFiltersSelected
          ? "Please select seller, region, route or stat number/index"
          : "No agreed volumes found"
      }
      noItemsContentRight={
        <FlatButton label={"Open filter"} onClick={() => openFilter()} />
      }
    />
  );
};
